// extracted by mini-css-extract-plugin
module.exports = {"toast":"styles_toast___7xyz","closeButton":"styles_closeButton__zZun1","content":"styles_content__Bn9Ol","link":"styles_link__XbqO5"};